<template>
  <div class="col-12">
    <div class="card card-body">
        <div class="col-12 table-responsive">
            <input type="text" placeholder="ابحث هنا..." v-model="q">
            <table class="table table-sm table-bordered table-striped">
                <thead>
                    <th>
                        م
                    </th>
                    <th>
                        الاسم
                    </th>
                    <th>
                        الجوال
                    </th>
                    <th>
                        اسم المستخدم
                    </th>
                    <th>
                        كلمة المرور
                    </th>
                    <th>
                        تاريخ الانضمام
                    </th>
                    <th>
                        تاريخ انتهاء الاشتراك
                    </th>
                </thead>
                <tbody>
                    <template v-for="(u, i) in users">
                        <tr v-if="u.name.includes(q) || q == '' || !q || u.phone.includes(q)" :key="u._id" :class="checkusercolor(u.exdate)">
                            <td>
                                {{ users.length - i }}
                            </td>
                            <td>
                                {{ u.name }}
                                <span class="btn btn-sm btn-outline-danger" v-if="!u.activated">{{ u.otp }}</span>
                            </td>
                            <td>
                                {{ u.phone }}
                            </td>
                            <td>
                                {{ u.username }}
                            </td>
                            <td>
                                <a href="javascript:;" @click="password(u)"><i class="fa fa-key"></i> عرض/تغيير</a>
                            </td>
                            <td>
                                {{ u.joindate.split("T")[0] }}
                            </td>
                            <td>
                                <a href="javascript:;" @click="exdate(u)"><i class="fa fa-edit"></i></a> 
                                <span :class="checkdate(u.exdate)">{{ u.exdate }}</span>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import templates from '../../../../Vuejs/src/views/pages/templates.vue';
export default {
  components: { templates },
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            users: [],
            q: ""
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post("https://server-enjazfile.tahdir.net/admin/users", {
                token: "5289765479"
            }).then(function(r){
                g.users = r.response.map(function(x){
                    if(!x.phone){
                        x.phone = ""
                    }
                    return x;
                })
            })
        },
        checkdate(date){
            if(new Date(date).getTime() >= new Date().getTime()){
                return 'text-success'
            }
        },
        checkusercolor(exdate){
            const oneDay = 24 * 60 * 60 * 1000;
            const firstDate = new Date();
            const secondDate = new Date(exdate);
    
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

            if(firstDate.getTime() <= secondDate.getTime()){
                if(diffDays >= 10){
                    return 'bg-light-success'
                }
            }else{
            }
        },
        password(u){
            var g = this;
            var t = prompt("كلمة المرور", u.password);
            if(t != u.password && t && t != ""){
                $.post("https://server-enjazfile.tahdir.net/admin/users/password", {
                    token: "5289765479",
                    user_id: u._id,
                    password: t
                }).then(function(r){
                    alert('تم تغيير كلمة المرور بنجاح')
                })
            }
        },
        exdate(u){
            var g = this;
            var t = prompt("تاريخ الانتهاء", u.exdate);
            if(t != u.exdate && t && t != ""){
                $.post("https://server-enjazfile.tahdir.net/admin/users/exdate", {
                    token: "5289765479",
                    user_id: u._id,
                    exdate: t
                }).then(function(r){
                    alert('تم تغيير التاريخ بنجاح')
                })
            }
        },
    }
}
</script>

<style>

</style>